import React, { useState, useEffect } from "react";
import Layout, { Container } from "../components/layout";
import { Link, useNavigate } from "react-router-dom";
import ButtonContainer from "../components/buttonContainer";
import { IoAddOutline } from "react-icons/io5";
import { useUser } from "../config/userProvider";
import { apiurl } from "../config/config";
// import Input from "../components/inputContainer";

import axios from "axios";
import { InfiLoader } from "../components/loader";
import SearchContainer from "../components/searchContainer";
import BackHeader from "../components/backHeader";
import Pagination from "../components/pagination";
import { toast } from "react-toastify";
import Card from "../components/card";
import DataNotFound from "../components/dataNotFound";

function Offers() {
  // const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [searchInput, setSearchInput] = useState("");

  const { userData } = useUser();
  let vendorObjId = userData?.vendorDetails?.vendorObjId;

  // =================== PAGINATION =================
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState("");
  const [deleteOfferIds, setDeleteOfferIds] = useState([]);
  const [isDeleted, WantToDelete] = useState(false);
  const [deleteOffersLoading, setDeleteOffersLoading] = useState(false);

  console.log("paginationData", paginationData);

  // Calculate the current items to display
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // =======================================================

  const fetchOfferData = async () => {
    setLoading(true);
    let data = JSON.stringify({
      vendorObjId: vendorObjId,
      page: currentPage,
      limit: JSON.parse(itemsPerPage),
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/offer/get`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setOffers(response.data.data);
        setLoading(false);
        console.log("offerResponse", response?.data);
        setPaginationData(response?.data?.pagination);
      })
      .catch((error) => {
        // setError(error);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   fetchOfferData();
  // }, [currentPage, itemsPerPage]);
  useEffect(() => {
    if (vendorObjId) {
      fetchOfferData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, itemsPerPage, vendorObjId]);

  const AllCheckedHandler = () => {
    if (filterdata.length !== deleteOfferIds.length) {
      filterdata.forEach((item) =>
        setDeleteOfferIds((prev) => [...prev, item._id]),
      );
    } else {
      setDeleteOfferIds([]);
    }
  };

  const CheckedHandler = (id) => {
    const contain = deleteOfferIds.includes(id);
    console.log("containcontain", contain, id);
    if (contain) {
      setDeleteOfferIds(deleteOfferIds.filter((i) => i !== id));
    } else {
      setDeleteOfferIds((prev) => [...prev, id]);
    }
  };

  const DeleteHandler = () => {
    setDeleteOffersLoading(true);
    let data = JSON.stringify({
      offerObjIds: deleteOfferIds,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/offer/delete`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          toast.success(
            response.data.message
              ? response.data.message
              : "Customer deleted successfully",
          );
          WantToDelete(false);
          fetchOfferData();
          setDeleteOffersLoading(false);
          setDeleteOfferIds([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setDeleteOffersLoading(false);
      });
  };

  // const toggleDrawer = () => {
  //   setIsOpen(!isOpen);
  // };

  const handleInputChange = (e) => {
    const { value } = e.target;
    setSearchInput(value);
  };

  const offerDetails = (id) => {
    navigate(`/offers/${id}`);
  };

  const filterdata = Array.isArray(offers)
    ? offers.filter(
        (offer) =>
          offer?.name
            ?.toLowerCase()
            ?.includes(searchInput?.toLowerCase() || "") ||
          offer?.description
            ?.toLowerCase()
            ?.includes(searchInput?.toLowerCase() || ""),
      )
    : [];

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <Layout>
      {isDeleted && (
        <Card.Confirmation
          message="Are you sure?"
          onConfirm={() => DeleteHandler()}
          onClose={() => WantToDelete(false)}
          loading={deleteOffersLoading}
          loadingTitle="Deleting..."
        />
      )}
      <Container>
        {loading === true ? (
          <InfiLoader maintext="Fetching Offers Data.." />
        ) : (
          <div className=" rounded-lg h-full w-full flex flex-col px-2 md:px-5 ">
            <div className="h-[96%] overflow-hidden">
              <BackHeader
                title={
                  <span className="flex flex-col md:flex-row items-center">
                    Offers
                    <span className="hidden lg:flex">
                      {" "}
                      - {paginationData?.totalOffers}
                    </span>
                    <select
                      value={itemsPerPage}
                      className="text-xs rounded text-black border px-2 mx-2"
                      onChange={(e) => setItemsPerPage(e.target.value)}
                    >
                      {/* <option value="10">10</option> */}
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="250">250</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </span>
                }
                rightSide={
                  <div className="flex items-center gap-2">
                    {deleteOfferIds.length > 0 && (
                      <button
                        onClick={() => WantToDelete(true)}
                        className="bg-red-50 text-xs hover:bg-[#c00218] border border-red-300 text-[#c00218] hover:text-white rounded-lg p-2 px-3 "
                      >
                        Delete
                      </button>
                    )}

                    <Link to="/offers/create">
                      <ButtonContainer icon={<IoAddOutline />}>
                        Create Offer
                      </ButtonContainer>
                    </Link>

                    <div className="hidden md:flexa">
                      <SearchContainer
                        placeholder={"Search Offer..."}
                        value={searchInput}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                }
              />
              <div className="flex flex-col  h-[90%] overflow-auto mt-2">
                <div className=" sm:rounded-lg h-full">
                  {filterdata && filterdata.length > 0 ? (
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0">
                        <tr>
                          <th scope="col" class="p-4">
                            <div class="flex items-center">
                              <input
                                id="checkbox-all-search"
                                type="checkbox"
                                checked={
                                  filterdata.length === deleteOfferIds.length
                                }
                                onClick={AllCheckedHandler}
                                class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 "
                              />
                              <label for="checkbox-all-search" class="sr-only">
                                checkbox
                              </label>
                            </div>
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Name
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Description
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Type
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Value
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Start Date
                          </th>
                          <th scope="col" className="px-6 py-3">
                            End Date
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Created At
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Action
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {filterdata &&
                          filterdata.length > 0 &&
                          filterdata.map((offer) => (
                            <tr
                              key={offer._id}
                              className="odd:bg-white even:bg-gray-50 border-b cursor-pointer"
                            >
                              <td class="w-4 p-4">
                                <div class="flex items-center">
                                  <input
                                    id="checkbox-table-search-1"
                                    type="checkbox"
                                    checked={deleteOfferIds.includes(offer._id)}
                                    onClick={() => CheckedHandler(offer._id)}
                                    class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500   focus:ring-2 "
                                  />
                                  <label
                                    for="checkbox-table-search-1"
                                    class="sr-only"
                                  >
                                    checkbox
                                  </label>
                                </div>
                              </td>
                              <td className="px-6 py-4 font-medium text-gray-900">
                                {offer.name}
                              </td>
                              <td className="px-6 py-4">{offer.description}</td>
                              <td className="px-6 py-4 capitalize">
                                <div
                                  className={
                                    offer.type === "percentage"
                                      ? "text-green-600"
                                      : "text-blue-600"
                                  }
                                >
                                  {offer.type}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                {offer.value}
                                {offer.type === "percentage" ? "%" : " rs"}
                              </td>
                              <td className="px-6 py-4">
                                {formatDate(offer.startDate)}
                              </td>
                              <td className="px-6 py-4">
                                {formatDate(offer.endDate)}
                              </td>
                              <td className="px-6 py-4">
                                {formatDate(offer.createdAt)}
                              </td>
                              <td
                                className="pl-4 sm:pl-6 py-4 text-blue-500 "
                                onClick={() => offerDetails(offer._id)}
                              >
                                view
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  ) : (
                    <DataNotFound.Page label="Offer" />
                  )}
                </div>
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              totalItems={paginationData?.totalPages}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </Container>
      {/* <ComingSoon/> */}
    </Layout>
  );
}

export default Offers;
